var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitGrey80(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09662 5.59478C5.38952 5.30189 5.86439 5.30189 6.15728 5.59478L21.9062 21.3437C22.1991 21.6366 22.1991 22.1115 21.9062 22.4044C21.6133 22.6973 21.1385 22.6973 20.8456 22.4044L5.09662 6.65544C4.80373 6.36255 4.80373 5.88768 5.09662 5.59478Z",
    fill: "#454A50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9053 5.59478C22.1982 5.88768 22.1982 6.36255 21.9053 6.65544L6.15639 22.4044C5.86349 22.6973 5.38862 22.6973 5.09573 22.4044C4.80283 22.1115 4.80283 21.6366 5.09573 21.3437L20.8447 5.59478C21.1376 5.30189 21.6124 5.30189 21.9053 5.59478Z",
    fill: "#454A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitGrey80);
export default __webpack_public_path__ + "static/media/exit_grey80.ee392417fad18e509724e5c5557a3eae.svg";
export { ForwardRef as ReactComponent };